export const LOADER_REASONS_FOR_ABSENCE          =      'LOADER_REASONS_FOR_ABSENCE';
export const GET_REASONS_FOR_ABSENCE             =      'GET_REASONS_FOR_ABSENCE';
export const REASONS_FOR_ABSENCE_FAIL            =      'REASONS_FOR_ABSENCE_FAIL';
export const SAVE_LOADER_REASONS_FOR_ABSENCE     =      'SAVE_LOADER_REASONS_FOR_ABSENCE';
export const FORM_REASONS_FOR_ABSENCE_FAIL       =      'FORM_REASONS_FOR_ABSENCE_FAIL';

